import { WhmStack } from "@securitize/reactjs-whm";
import { useGetPreviouslyOwnedAssets } from "../../../../../../data/usePortfolio";
import { ErrorPage } from "../../../../../shared/ErrorPage";
import AssetPreviouslyOwnedCard from "./AssetPreviouslyOwnedCard";
import SkeletonCard from "./SkeletonCard";

export default function PreviouslyOwned() {
  const previouslyOwnedAssets = useGetPreviouslyOwnedAssets();

  if (previouslyOwnedAssets.isLoading) {
    return <SkeletonCard />;
  }

  if (previouslyOwnedAssets.isError) {
    return (
      <ErrorPage
        errorCode={previouslyOwnedAssets.error.correlationId}
        onRefresh={() => previouslyOwnedAssets.refetch()}
      />
    );
  }

  return (
    <WhmStack gap="16px">
      {previouslyOwnedAssets.data?.previouslyOwnedAssets.map((asset) => {
        return <AssetPreviouslyOwnedCard key={asset.tokenId} {...asset} />;
      })}
    </WhmStack>
  );
}
